import { gql, useQuery } from "@apollo/client";

export const GET_COMPLETE_CHANNEL_INFO = gql`
    query GetCompleteChannelInfo($channelId: Long!) {
        getCompleteChannelInfo(channelId: $channelId) {
            channel {
                id
                channelName
                companyName
                companyAddress
                contactName
                contactPhone
                email
                taxRate
                taxId
                isAutoGenerate
                status
                remark
            }
            channelBase {
                id
                channelId
                bdName
                englishShortName
                onboardingDocumentsJson
                responsibleNode
                customerType
                pickupHubMatchingType
                fixedPickupHubId
                contractingPartyId
            }
            channelSettlement {
                id
                channelId
                netDay
                orderQuantityLimit
                orderDailyLimit
                orderCycleLimit
                gri
                dimDivisor
                settlementTrackingPoint
                billingCycleConfiguration
                weightCalculationMode
                weightCalculationThresholdX
                settlementMode
                timeZoneIana
                schemeLimitNode
                settlementCustomerType
                billType
                billUnitType
                billTypeCycleList {
                    billType
                    cycleType
                }
            }
            channelContact {
                id
                channelId
                financeContactName
                financeContactEmail
                financeContactsJson
                itContactName
                itContactEmail
            }
            channelFulfillment {
                id
                channelId
                forwardTimeValue
                forwardTimeDisplayUnit
                failureMethod
                storageTimeValue
                storageTimeDisplayUnit
                returnTimeValue
                returnTimeDisplayUnit
                trackDiscontinuationAssessmentType
                trackDiscontinuationAssessmentDays
            }
            channelPortalConfig {
                channelId
                allowQueryAbnormalWeighingInfo
            }
        }
    }
`;

export interface CompleteChannelInfo {
    channel: {
        id: string;
        channelName: string;
        companyName: string;
        companyAddress?: string;
        contactName?: string;
        contactPhone?: string;
        email?: string;
        taxRate?: string;
        taxId?: string;
        isAutoGenerate: boolean;
        status: number;
        remark?: string;
    };
    channelBase?: {
        id: string;
        channelId: number;
        bdName?: string;
        englishShortName?: string;
        onboardingDocumentsJson?: string;
        responsibleNode?: number;
        customerType?: number;
        pickupHubMatchingType?: number;
        fixedPickupHubId?: number;
        contractingPartyId?: number | null;
    };
    channelSettlement?: {
        id: string;
        channelId: number;
        netDay?: number;
        orderQuantityLimit?: number;
        orderDailyLimit?: number;
        orderCycleLimit?: number;
        gri?: string;
        dimDivisor?: number;
        settlementTrackingPoint?: string | null;
        billingCycleConfiguration?: number;
        weightCalculationMode?: number;
        weightCalculationThresholdX?: number;
        settlementMode?: number;
        timeZoneIana?: string;
        schemeLimitNode?: string;
        settlementCustomerType?: number;
        billType?: string;
        billUnitType?: number;
        billTypeCycleList?: Array<{ billType: number; cycleType: number }>;
    };
    channelContact?: {
        id: string;
        channelId: number;
        financeContactName?: string;
        financeContactEmail?: string;
        financeContactsJson?: string;
        itContactName?: string;
        itContactEmail?: string;
    };
    channelFulfillment?: {
        id: string;
        channelId: number;
        forwardTimeValue?: number;
        forwardTimeDisplayUnit?: number;
        failureMethod?: number;
        storageTimeValue?: number;
        storageTimeDisplayUnit?: number;
        returnTimeValue?: number;
        returnTimeDisplayUnit?: number;
        trackDiscontinuationAssessmentType?: number;
        trackDiscontinuationAssessmentDays?: number | null;
    };
    channelPortalConfig?: {
        channelId: number;
        allowQueryAbnormalWeighingInfo: boolean;
    };
}

export interface GetCompleteChannelInfoResponse {
    getCompleteChannelInfo: CompleteChannelInfo | null;
}

export interface GetCompleteChannelInfoVariables {
    channelId: number;
}

export const useCompleteChannelInfo = (channelId: number | null) => {
    return useQuery<GetCompleteChannelInfoResponse, GetCompleteChannelInfoVariables>(
        GET_COMPLETE_CHANNEL_INFO,
        {
            variables: { channelId: channelId! },
            skip: !channelId,
            fetchPolicy: 'network-only' // 每次都从服务器获取最新数据
        }
    );
};

